import { GET_DASHBOARD_DATA } from '../../constants/system/actions';

const getDashboardData: Function = (payload?: ActionPayload, resolve?: Function, reject?: Function): ReduxAction => ({
  type: GET_DASHBOARD_DATA, payload, resolve, reject,
});

export default getDashboardData;
